var exports = {
  "az": "Box__PoXnpX",
  "EY": "Text__RQ8qBl",
};

module.exports = exports;
